import { IoIosPeople } from "react-icons/io";
import { BiCodeAlt } from "react-icons/bi";
import { DiJavascript1 } from "react-icons/di";
import { AiFillFilePdf } from "react-icons/ai";
import { IoLocationSharp } from "react-icons/io5";

export default function Hero() {
  type Tag = {
    name: string;
    icon: React.ReactNode;
  };

  const tags: Tag[] = [
    {
      name: "React Developer",
      icon: <BiCodeAlt className="text-lg mr-2" />,
    },
    {
      name: "Open to collaborate",
      icon: <IoIosPeople className="text-lg mr-2" />,
    },
    {
      name: "JavaScript Lover",
      icon: <DiJavascript1 className="text-lg mr-2" />,
    },
  ];

  return (
    <div className="mt-16 sm:mt-32 px-4">
      <div className="mx-auto max-w-3xl">
        <div className="flex flex-wrap gap-y-4">
          <div className="mr-5">
            <img
              className="w-16 h-16 sm:w-24 sm:h-24 border border-primary sm:p-1 bg-primary rounded-full"
              src="/assets/img/me.jpg"
              alt="me"
            />
          </div>
          <div className="flex-1">
            <h3 className="text-3xl font-semibold dark:text-white">Asifur</h3>
            <p className="sm:w-96 mt-1 dark:text-dark_text text-subText font-semibold">
              Frontend Developer, Open source{" "}
              <a
                href="https://github.com/asifurrahaman754"
                className="underline decoration-primary text-primary"
              >
                contributor
              </a>{" "}
              , and a tech enthusiast.
            </p>

            <div className="flex flex-wrap gap-y-2 text-xs sm:text-sm items-center mt-3 font-semibold text-subText dark:text-dark_text">
              <p className="flex items-center mr-4">
                <IoLocationSharp className="mr-2 text-lg" /> Chattogram,
                Bangladesh
              </p>
              <a
                href="https://drive.google.com/file/d/12oiADJEPhcr4hpfmbDgwqZmRtzAuxHn9/view"
                className="flex items-center"
                target="_blank"
                rel="noreferrer"
              >
                <AiFillFilePdf className="mr-2 text-lg" />
                <span className="hover:underline">View resume</span>
              </a>
            </div>
          </div>
        </div>

        <p className="mt-7 text-base sm:text-xl dark:text-white">
          Welcome to my digital profile where I shared about my learnings, the
          project i built, becoming a better developer and growing a career in
          tech.
        </p>

        <ul className="flex flex-wrap gap-y-3 mt-5">
          {tags.map(({ name, icon }, index) => (
            <li
              key={index}
              className="flex text-xs font-semibold items-center mr-5 px-3 py-1 sm:px-4 sm:py-2 bg-grey dark:bg-dark_bg dark:text-white rounded-full"
            >
              {icon}
              {name}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
